import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import isEmpty from 'src/app/lib/validte';

@Component({
  selector: 'app-date-to-date-search',
  templateUrl: './date-to-date-search.component.html',
  styleUrls: ['./date-to-date-search.component.scss']
})
export class DateToDateSearchComponent {
  @Output() dateToDateSearch = new EventEmitter<any>();

  form: FormGroup

  startDate = '';
  endDate = '';

  btnLoading: any = ""
  loader: boolean = true

  constructor(private _fb: FormBuilder) {
    this.form = this._fb.group({
      startDate: '',
      endDate: ''
    })
  }

  ngAfterViewInit() {
    this.loader = false
  }

  startDateChange(event: any) {
    let dt = '';
    if (event.value) {
      dt = moment(event.value).format('YYYY-MM-DD');
    }
    this.startDate = dt;
  }

  endDateChange(event: any) {
    let dt = '';
    if (event.value) {
      dt = moment(event.value).format('YYYY-MM-DD');
    }
    this.endDate = dt;
  }

  handleSearch(type = 'searchType') {
    if (type === 'clear') {
      this.form.reset()
      this.startDate = ''
      this.endDate = ''
    }
    const dateFilter = {
      id: 'sefd_',
      filterValue: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
      type: type
    }
    this.dateToDateSearch.emit(dateFilter)
  }

}
